import { lazy } from "react";

const BillPayment = lazy(() =>
  import(
    "./pages/BillPayment/BillPayment" /* webpackChunkName: 'BillPayment' */
  )
);

const PaymentResult = lazy(() =>
  import(
    "./pages/Payments/PaymentResult" /* webpackChunkName: 'PaymentResult' */
  )
);

const MarketPlace = lazy(() =>
  import(
    "./pages/MarketPlace/MarketPlace" /* webpackChunkName: 'MarketPlace' */
  )
);

const MarketPlaceRegistration = lazy(() =>
  import(
    "./pages/MarketPlace/OriginalApproach/MarketPlace" /* webpackChunkName: 'MarketPlaceRegistration' */
  )
);

const DigitalPromos = lazy(() =>
  import(
    "./pages/DigitalPromos/DigitalPromos" /* webpackChunkName: 'DigitalPromos' */
  )
);

const RedPass = lazy(() =>
  import("./pages/Campaigns/RedPass" /* webpackChunkName: 'RedPass' */)
);
const MyAccount = lazy(() =>
  import("./pages/MyAccount/MyAccount" /* webpackChunkName: 'MyAccount' */)
);

const MyAccountDashboard = lazy(() =>
  import(
    "./pages/MyAccount/Dashboard/Dashboard" /* webpackChunkName: 'Dashboard' */
  )
);

const MyAccountBundleActivation = lazy(() =>
  import(
    "./pages/MyAccount/BundleActivation/BundleActivation" /* webpackChunkName: 'BundleActivation' */
  )
);

const MyAccountVodafoneYouBundleActivation = lazy(() =>
  import(
    "./pages/MyAccount/VodafoneYouBundleActivation/VodafoneYouBundleActivation" /* webpackChunkName: 'VodafoneYouBundleActivation' */
  )
);

const MyAccountBilling = lazy(() =>
  import("./pages/MyAccount/Billing/Billing" /* webpackChunkName: 'Billing' */)
);

const MyAccountProductsServices = lazy(() =>
  import(
    "./pages/MyAccount/ProductsServices/ProductsServices" /* webpackChunkName: 'ProductsServices' */
  )
);

const MyAccountCallAnalysis = lazy(() =>
  import(
    "./pages/MyAccount/CallAnalysis/CallAnalysis" /* webpackChunkName: 'CallAnalysis' */
  )
);

const MyAccountBillsHistory = lazy(() =>
  import(
    "./pages/MyAccount/BillsHistory/BillsHistory" /* webpackChunkName: 'BillsHistory' */
  )
);

const MyAccountPukRetrieval = lazy(() =>
  import(
    "./pages/MyAccount/PukRetrieval/PukRetrieval" /* webpackChunkName: 'PukRetrieval' */
  )
);

const MyAccountRetention = lazy(() =>
  import(
    "./pages/MyAccount/Retention/Retention" /* webpackChunkName: 'Retention' */
  )
);

const MyAccountTvSettings = lazy(() =>
  import(
    "./pages/MyAccount/TvSettings/TvSettings" /* webpackChunkName: 'TvSettings' */
  )
);

const MyAccountTvDevices = lazy(() =>
  import(
    "./pages/MyAccount/TvDevices/TvDevices" /* webpackChunkName: 'TvDevices' */
  )
);

const MyAccountTvHistory = lazy(() =>
  import(
    "./pages/MyAccount/TvHistory/TvHistory" /* webpackChunkName: 'TvHistory' */
  )
);

const MyAccountTvPersonalDetails = lazy(() =>
  import(
    "./pages/MyAccount/TvSettings/TvPersonalDetails" /* webpackChunkName: 'TvPersonalDetails' */
  )
);

const MyAccountTvPaymentMethod = lazy(() =>
  import(
    "./pages/MyAccount/TvSettings/TvPaymentMethod" /* webpackChunkName: 'TvPaymentMethod' */
  )
);

const MyAccountTvTermsConditions = lazy(() =>
  import(
    "./pages/MyAccount/TvSettings/TvTermsConditions" /* webpackChunkName: 'TvTermsConditions' */
  )
);

const MyAccountWifiSettings = lazy(() =>
  import(
    "./pages/MyAccount/WifiSettings/WifiSettings" /* webpackChunkName: 'WifiSettings' */
  )
);

const MyAccountBarringCategories = lazy(() =>
  import(
    "./pages/MyAccount/BarringCategories/BarringCategories" /* webpackChunkName: 'BarringCategories' */
  )
);

const MyAccountPsms = lazy(() =>
  import(
    "./pages/MyAccount/BarringCategories/Psms/Psms" /* webpackChunkName: 'Psms' */
  )
);

const MyAccountBro = lazy(() =>
  import(
    "./pages/MyAccount/BarringCategories/Bro" /* webpackChunkName: 'Bro' */
  )
);

const MyAccountBrr = lazy(() =>
  import(
    "./pages/MyAccount/BarringCategories/Brr" /* webpackChunkName: 'Brr' */
  )
);

const MyAccountSettlements = lazy(() =>
  import("./pages/MyAccount/Settlements" /* webpackChunkName: 'Settlements' */)
);

const MyAccountNetNeutrality = lazy(() =>
  import(
    "./pages/MyAccount/NetNeutrality/SpeedTestPage/NetNeutrality" /* webpackChunkName: 'NetNeutrality' */
  )
);

const MyAccountNetNeutralityTicket = lazy(() =>
  import(
    "./pages/MyAccount/NetNeutrality/OpenTicketPage/NetNeutralityTicket" /* webpackChunkName: 'NetNeutralityTicket' */
  )
);

const MyAccountNNRequestHistory = lazy(() =>
  import(
    "./pages/MyAccount/NetNeutrality/RequestHistory/RequestHistory" /* webpackChunkName: 'NetNeutralityRequestHistory' */
  )
);

const MyAccountNNMyPlanPage = lazy(() =>
  import(
    "./pages/MyAccount/NetNeutrality/MyPlanPage/MyPlanPage" /* webpackChunkName: 'NetNeutralityMyPlanPage' */
  )
);

const MyAccountDirectDebit = lazy(() =>
  import(
    "./pages/MyAccount/DirectDebit/DirectDebit" /* webpackChunkName: 'DirectDebit' */
  )
);

const MyAccountMyOffers = lazy(() =>
  import(
    "./pages/MyAccount/MyOffers/MyOffers" /* webpackChunkName: 'MyAccountMyOffers' */
  )
);

const MyAccountVdslOffer = lazy(() =>
  import(
    "./pages/MyAccount/MyOffers/VDSL/Convergence" /* webpackChunkName: 'Convergence' */
  )
);

const MyAccountOffer = lazy(() =>
  import(
    "./pages/MyAccount/MyOffers/Offer/Offer" /* webpackChunkName: 'MyAccountOffer' */
  )
);

const MyAccountTvOffer = lazy(() =>
  import(
    "./pages/MyAccount/MyOffers/TvOffer/TvOffer" /* webpackChunkName: 'Convergence' */
  )
);

const MyAccountPaymentsHistory = lazy(() =>
  import(
    "./pages/MyAccount/PaymentsHistory/PaymentsHistory" /* webpackChunkName: 'PaymentsHistory' */
  )
);

const MyAccountAskOnce = lazy(() =>
  import("./pages/MyAccount/AskOnce/AskOnce" /* webpackChunkName: 'AskOnce' */)
);

const MyAccountManageEsim = lazy(() =>
  import("./pages/MyAccount/Esim/Esim" /* webpackChunkName: 'Esim' */)
);

const MyAccountMajorIncidents = lazy(() =>
  import(
    "./pages/MyAccount/MajorIncidents/MajorIncidents" /* webpackChunkName: 'MajorIncidents' */
  )
);

const MyAccountSavedCards = lazy(() =>
  import(
    "./pages/MyAccount/SavedCards/SavedCards" /* webpackChunkName: 'SavedCards' */
  )
);

const MyAccountTechSupport = lazy(() =>
  import(
    "./pages/MyAccount/TechSupport/TechSupport" /* webpackChunkName: 'TechSupport' */
  )
);

const MyAccountWifiTroubleshooting = lazy(() =>
  import(
    "./pages/MyAccount/TechSupport/Flows/WifiTroubleshooting" /* webpackChunkName: 'TechSupportWifiTroubleshooting' */
  )
);

const MyAccountCpeManagement = lazy(() =>
  import(
    "./pages/MyAccount/CpeManagement/CpeManagement" /* webpackChunkName: 'CpeManagement' */
  )
);

const NetNeutrality = lazy(() =>
  import(
    "./pages/NetNeutrality/NetNeutrality" /* webpackChunkName: 'NetNeutralityMobile' */
  )
);

const OffersOTP = lazy(() =>
  import("./pages/Offers/SameTariff/OTP" /* webpackChunkName: 'offersOTP ' */)
);

const OTTRegistration = lazy(() =>
  import(
    "./pages/OTTRegistration/OTTRegistration" /* webpackChunkName: 'OTTRegistration' */
  )
);

const OfferWeb = lazy(() =>
  import(
    "./pages/Offers/SameTariff/OfferWeb" /* webpackChunkName: 'OfferWeb' */
  )
);

const OrderTrackingTool = lazy(() =>
  import(
    "./pages/OrderTrackingTool/OrderTrackingTool" /* webpackChunkName: 'OrderTrackingTool' */
  )
);

const PlanSelector = lazy(() =>
  import(
    "./pages/PlanSelector/PlanSelector" /* webpackChunkName: 'PlanSelector' */
  )
);

const Koftis = lazy(() =>
  import("./pages/Koftis/Koftis" /* webpackChunkName: 'Koftis' */)
);

const DataBundles = lazy(() =>
  import(
    "./pages/DataBundles/DataBundles" /* webpackChunkName: 'DataBundles' */
  )
);

const DeviceInstallmentsPayment = lazy(() =>
  import(
    "./pages/DeviceInstallmentsPayment/DeviceInstallmentsPayment" /* webpackChunkName: 'DeviceInstallmentsPayment' */
  )
);

const PrepaidYou = lazy(() =>
  import("./pages/PrepaidYou/PrepaidYou" /* webpackChunkName: 'PrepaidYou' */)
);

const PrepaidTourist = lazy(() =>
  import("./pages/PrepaidTourist/" /* webpackChunkName: 'PrepaidTourist' */)
);

const PrepaidMsisdn = lazy(() =>
  import(
    "./pages/PrepaidMsisdn/PrepaidMsisdn" /* webpackChunkName: 'PrepaidMsisdn' */
  )
);

const HelpMeChoose = lazy(() =>
  import(
    "./pages/HelpMeChoose/HelpMeChoose" /* webpackChunkName: 'HelpMeChoose' */
  )
);

const TopUp = lazy(() =>
  import("./pages/TopUp/TopUp" /* webpackChunkName: 'TopUp' */)
);

const SAMOffer = lazy(() =>
  import("./pages/Offers/SAMOffer" /* webpackChunkName: 'SAMOffer' */)
);

const DigitalReceipts = lazy(() =>
  import(
    "./pages/DigitalReceipts/DigitalReceipts" /* webpackChunkName: 'DigitalReceipts' */
  )
);

const Settings = lazy(() =>
  import("./pages/Settings/Settings" /* webpackChunkName: 'Settings' */)
);

const GDPR = lazy(() =>
  import("./pages/GDPR/GDPR" /* webpackChunkName: 'GDPR' */)
);

const eBillManagement = lazy(() =>
  import(
    "./pages/eBillManagement/eBillManagement" /* webpackChunkName: 'eBillManagement' */
  )
);

const OfferMobileTarget = lazy(() =>
  import(
    "./pages/Offers/OfferMobileTarget" /* webpackChunkName: 'OfferMobileTarget' */
  )
);

const NewLineUp = lazy(() =>
  import(
    "./pages/Offers/NewLineUp/NewLineUp" /* webpackChunkName: 'NewLineUp' */
  )
);

const Dsl2vdsl = lazy(() =>
  import(
    "./pages/Offers/FBG/Dsl2vdsl/Dsl2vdsl" /* webpackChunkName: 'Dsl2vdsl' */
  )
);

const PersonalizedOffer = lazy(() =>
  import(
    "./pages/Offers/PersonalizedOffer/PersonalizedOffer" /* webpackChunkName: 'PersonalizedOffer' */
  )
);

const MyOffers = lazy(() =>
  import("./pages/Offers/MyOffers/MyOffers" /* webpackChunkName: 'MyOffers' */)
);

const DocumentsUpload = lazy(() =>
  import(
    "./pages/DocumentsUpload/DocumentsUpload" /* webpackChunkName: 'DocumentsUpload' */
  )
);

const TvUpgrade = lazy(() =>
  import(
    "./pages/Offers/FBG/TvUpgrade/TvUpgrade" /* webpackChunkName: 'TvUpgrade' */
  )
);

const TobiLanding = lazy(() =>
  import("./pages/Chat/Landing" /* webpackChunkName: 'TobiLanding' */)
);

const Eve = lazy(() => import("./pages/Eve/Eve" /* webpackChunkName: 'Eve' */));

const SmartBill = lazy(() =>
  import("./pages/SmartBill/SmartBill" /* webpackChunkName: 'SmartBill' */)
);

const FixedPlansConfigurator = lazy(() =>
  import(
    "./pages/FixedPlansConfigurator/FixedPlansConfigurator" /* webpackChunkName: 'FixedPlansConfigurator' */
  )
);

const FixedContract = lazy(() =>
  import(
    "./pages/FixedContract/FixedContract" /* webpackChunkName: 'FixedContract' */
  )
);

const KoftisEnable = lazy(() =>
  import(
    "./pages/KoftisEnable/KoftisEnable" /* webpackChunkName: 'KoftisEnable' */
  )
);

const AnonymousAskOnce = lazy(() =>
  import(
    "./pages/AnonymousAskOnce/AnonymousAskOnce" /* webpackChunkName: 'AnonymousAskOnce' */
  )
);

const EsimActivation = lazy(() =>
  import(
    "./pages/EsimActivation/EsimActivation" /* webpackChunkName: 'EsimActivation' */
  )
);

const FixedSameTariff = lazy(() =>
  import(
    "./pages/Offers/FixedSameTariff/FixedSameTariff" /* webpackChunkName: 'FixedSameTariff' */
  )
);

const Unemployment = lazy(() =>
  import(
    "./pages/Unemployment/Unemployment" /* webpackChunkName: 'Unemployment' */
  )
);

const AnonymousMajorIncidents = lazy(() =>
  import(
    "./pages/AnonymousMajorIncidents/AnonymousMajorIncidents" /* webpackChunkName: 'AnonymousMajorIncidents' */
  )
);

const EsimConsent = lazy(() =>
  import(
    "./pages/EsimConsent/EsimConsent" /* webpackChunkName: 'EsimConsent' */
  )
);

const MobileMultipleOffers = lazy(() =>
  import(
    "./pages/Offers/MobileMultipleOffers/MobileMultipleOffers" /* webpackChunkName: 'MobileMultipleOffers' */
  )
);

const Combo = lazy(() =>
  import("./pages/Combo/Combo" /* webpackChunkName: 'Combo' */)
);

const Basket = lazy(() =>
  import("./pages/Basket/Basket" /* webpackChunkName: 'Basket' */)
);

const VBGDigitalJourneys = lazy(() =>
  import(
    "./pages/VBGDigitalJourneys/VBGDigitalJourneys" /* webpackChunkName: 'VBGDigitalJourneys' */
  )
);

const ChangePassword = lazy(() =>
  import(
    "./pages/ChangePassword/ChangePassword" /* webpackChunkName: 'ChangePassword' */
  )
);

const TvFilter = lazy(() =>
  import("./pages/TvFilter/TvFilter" /* webpackChunkName: 'TvFilter' */)
);

const ChangeBillingAddress = lazy(() =>
  import(
    "./pages/ChangeBillingAddress/ChangeBillingAddress" /* webpackChunkName: 'ChangeBillingAddress' */
  )
);

const RoojoomFlows = lazy(() =>
  import("./pages/Roojoom/index" /* webpackChunkName: 'RoojoomFlows' */)
);

const CheckoutOnboarding = lazy(() =>
  import(
    "./pages/CheckoutOnboarding/Onboarding" /* webpackChunkName: 'CheckoutOnboarding' */
  )
);

const Prepaid = lazy(() => import("./pages/Prepaid"));

function shouldUseRouter(page) {
  // insert here the pages that require a Router
  if (page === "MyAccount") return true;
  if (page === "ChangeBillingAddress") return true;

  return false;
}

export { shouldUseRouter };

export default {
  BillPayment: BillPayment,
  PaymentResult: PaymentResult,
  RedPass: RedPass,
  MyAccount: MyAccount,
  MyAccountDashboard: MyAccountDashboard,
  MyAccountBilling: MyAccountBilling,
  MyAccountProductsServices: MyAccountProductsServices,
  MyAccountPukRetrieval: MyAccountPukRetrieval,
  MyAccountCallAnalysis: MyAccountCallAnalysis,
  MyAccountRetention: MyAccountRetention,
  MyAccountBundleActivation: MyAccountBundleActivation,
  MyAccountVodafoneYouBundleActivation: MyAccountVodafoneYouBundleActivation,
  MyAccountTvSettings: MyAccountTvSettings,
  MyAccountTvDevices: MyAccountTvDevices,
  MyAccountTvHistory: MyAccountTvHistory,
  MyAccountTvPersonalDetails: MyAccountTvPersonalDetails,
  MyAccountTvPaymentMethod: MyAccountTvPaymentMethod,
  MyAccountTvTermsConditions: MyAccountTvTermsConditions,
  MyAccountWifiSettings: MyAccountWifiSettings,
  MyAccountPsms: MyAccountPsms,
  MyAccountBro: MyAccountBro,
  MyAccountBrr: MyAccountBrr,
  MyAccountBarringCategories: MyAccountBarringCategories,
  MyAccountNetNeutrality: MyAccountNetNeutrality,
  MyAccountNetNeutralityTicket: MyAccountNetNeutralityTicket,
  MyAccountNNRequestHistory: MyAccountNNRequestHistory,
  MyAccountNNMyPlanPage: MyAccountNNMyPlanPage,
  MyAccountDirectDebit: MyAccountDirectDebit,
  MyAccountMyOffers: MyAccountMyOffers,
  MyAccountVdslOffer: MyAccountVdslOffer,
  MyAccountOffer: MyAccountOffer,
  MyAccountTvOffer: MyAccountTvOffer,
  MyAccountBillsHistory: MyAccountBillsHistory,
  MyAccountPaymentsHistory: MyAccountPaymentsHistory,
  MyAccountAskOnce: MyAccountAskOnce,
  MyAccountManageEsim,
  MyAccountMajorIncidents: MyAccountMajorIncidents,
  MyAccountSavedCards: MyAccountSavedCards,
  MyAccountTechSupport: MyAccountTechSupport,
  MyAccountWifiTroubleshooting: MyAccountWifiTroubleshooting,
  MyAccountCpeManagement: MyAccountCpeManagement,
  NetNeutrality: NetNeutrality,
  OffersOTP: OffersOTP,
  OTTRegistration: OTTRegistration,
  OfferWeb: OfferWeb,
  OrderTrackingTool: OrderTrackingTool,
  MarketPlace: MarketPlace,
  MarketPlaceRegistration: MarketPlaceRegistration,
  DigitalPromos: DigitalPromos,
  PlanSelector: PlanSelector,
  Koftis: Koftis,
  TopUp: TopUp,
  SAMOffer: SAMOffer,
  DigitalReceipts: DigitalReceipts,
  DataBundles: DataBundles,
  Prepaid,
  PrepaidYou: PrepaidYou,
  PrepaidTourist,
  PrepaidMsisdn: PrepaidMsisdn,
  Settings: Settings,
  MyAccountSettlements,
  GDPR: GDPR,
  eBillManagement: eBillManagement,
  OfferMobileTarget: OfferMobileTarget,
  NewLineUp: NewLineUp,
  Dsl2vdsl: Dsl2vdsl,
  PersonalizedOffer: PersonalizedOffer,
  MyOffers: MyOffers,
  DocumentsUpload: DocumentsUpload,
  TvUpgrade: TvUpgrade,
  TobiLanding: TobiLanding,
  Eve: Eve,
  SmartBill: SmartBill,
  FixedPlansConfigurator: FixedPlansConfigurator,
  FixedContract: FixedContract,
  KoftisEnable: KoftisEnable,
  AnonymousAskOnce: AnonymousAskOnce,
  EsimActivation,
  HelpMeChoose: HelpMeChoose,
  FixedSameTariff: FixedSameTariff,
  Unemployment,
  AnonymousMajorIncidents: AnonymousMajorIncidents,
  MobileMultipleOffers: MobileMultipleOffers,
  Combo,
  Basket,
  VBGDigitalJourneys: VBGDigitalJourneys,
  EsimConsent,
  ChangePassword: ChangePassword,
  TvFilter,
  ChangeBillingAddress: ChangeBillingAddress,
  DeviceInstallmentsPayment: DeviceInstallmentsPayment,
  RoojoomFlows: RoojoomFlows,
  CheckoutOnboarding
};
